import React from "react";
import { Text, View } from "react-native";
import { useLanguage } from "../screens/LanguageProvider";

export default function FooterComponent() {
  const { t } = useLanguage();
  return (
    <View className="absolute bottom-0 w-full z-10">
      <View className="px-6 py-3 border-t border-gray-300 bg-white items-center rounded-t-3xl shadow-lg">
        <Text className="text-center text-gray-800 text-sm font-kanit flex-row items-center justify-center">
          {/* Developed by{" "} */}
          {t("developed_by")}{" "}
          <Text className="text-[#F17736] underline font-semibold">
            Business Digital Transformation Department
          </Text>
          <Text className="text-[#F17736] underline font-semibold">
            {" "}
            Ver 2.2.8
          </Text>
        </Text>
      </View>
    </View>
  );
}
